/**
 * dataLayer-events, zelfde vorm als popcarte's `ai_product_modal`, zodat GTM of Convert er
 * later een goal van kan maken.
 */
export type TrackAction =
  | 'cta_view'
  | 'open'
  | 'photo_selected'
  | 'transformation_start'
  | 'transformation_success'
  | 'transformation_error'
  | 'retry'
  | 'other_photo'
  | 'cancel'
  | 'apply_success'
  | 'apply_error'
  | 'close';

let trackedStyle: string | undefined;

/** Onthoudt de stijl die de klant koos, voor de volgende events. */
export function setTrackedStyle(styleId: string): void {
  trackedStyle = styleId;
}

export function track(action: TrackAction, value?: string | number): void {
  try {
    window.dataLayer = window.dataLayer ?? [];
    window.dataLayer.push({
      event: 'ai_photo_modal',
      action_type: action,
      action_value: value,
      ...(trackedStyle ? { aps_style: trackedStyle } : {}),
    });
  } catch {
    /* analytics mag nooit de flow breken */
  }
}
